import RegionTitle from './regionTitle/RegionTitle';
import SortingMenu from './sortingMenu/SortingMenu';
import { FC, memo } from 'react';
import Box from '@/components/UI/box/Box';
import styles from './FilterSorting.module.scss';
import { SearchDataProps } from '@/components/search/_types/searchDataType';
interface Props {
  data: SearchDataProps;
}
const FilterSorting: FC<Props> = ({
  data
}) => {
  return <Box className={styles['filter-sorting-section']} data-sentry-element="Box" data-sentry-component="FilterSorting" data-sentry-source-file="FilterSorting.tsx">
      <RegionTitle data={data} data-sentry-element="RegionTitle" data-sentry-source-file="FilterSorting.tsx" />
      <SortingMenu data-sentry-element="SortingMenu" data-sentry-source-file="FilterSorting.tsx" />
    </Box>;
};
export default memo(FilterSorting);